module.exports = __webpack_public_path__ + "img/total.b76bd023.png";